@import './theme/fonts.css';
@import './theme/tokens.css';

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  --avatar-safe-top: 0px;
  --avatar-safe-bottom: 0px;
  --avatar-ime-bottom: 0px;
  --avatar-kb-safe-bottom: max(
    env(safe-area-inset-bottom, 0px),
    var(--avatar-safe-bottom, 0px)
  );
  background: var(--avatar-surface-canvas);
}

html,
body,
#root {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: var(--avatar-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--avatar-surface-canvas);
  color: var(--avatar-text-primary);
}

button,
textarea,
input {
  font-family: inherit;
}

button:focus-visible,
textarea:focus-visible,
input:focus-visible {
  outline: 2px solid var(--avatar-focus-ring);
  outline-offset: 2px;
}

/* Mobile WebView only — keep the panel inside visualViewport when the keypad opens.
   Web iframe layout is unchanged (still 100% of the iframe). */
html[data-surface='webview'],
html[data-surface='webview'] body,
html[data-surface='webview'] #root {
  height: var(--avatar-vv-height, 100%);
  max-height: var(--avatar-vv-height, 100%);
}

/* Android WebView paints native borders/padding on disabled inputs; keep the
   pill chrome on the wrapper and reset the control. */
html[data-surface='webview'] input {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
}

html[data-surface='webview'] input:focus,
html[data-surface='webview'] input:focus-visible {
  outline: none;
}

html.keyboard-open [data-powered-by] {
  display: none;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background: var(--avatar-color-gray-300);
  border-radius: var(--avatar-radius-pill);
}

::-webkit-scrollbar-track {
  background: transparent;
}
